import React, { Component } from 'react';
import moment from 'moment';
import { CSVLink } from "react-csv";
import formDataSchema from '../../../schema/bill-header-wise-report';
import * as R from 'ramda';
// import Pagination from "react-js-pagination";
import DateRange from '../../../components/FormComponent/DateRange';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import { Pagination } from 'antd';

const $ = require('jquery');
const {homepage} = networkList;
class Bill_Header_Wise extends Component {
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            date: '',
            appTime: [],
            headding: null,
            postdata: {},
            filtereData: [],
            reportData: [],
            reportHead: [],
            reportExcelData: [],
            visible: false,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            activePage: 1,
            totalItems: 0,
            isLoading: false,
            downloadStatus: 0,
            loadding: false,
            'thead': [],
            'tbody': [],
            'downloadtbody': []
        };
    }

    componentDidMount() {
        this.setState((state) => ({ 'activePage': 1, totalItems: 0, filtereData: formDataSchema.feilds }), () => {
            this.fetchData(this.state.filtereData);
            // this.renderHead();
            this.loadPage()
        });
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }


    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
    }

    fetchData(fetchData) {
        var payload = {
            "from_date": this.state.dateFrom,
            "to_date": this.state.dateTo,
            "page": this.state.activePage
        }
        console.log('payload:', payload);
    }

    handlePageChange(page) {
        console.log(page);
        this.setState((state) => ({
            activePage: page,
        }), () => {
            this.loadPage();
        })
    }

    loadPage = (isDatefilter = false) => {
        try {
            let This = this;
            let { activePage } = this.state;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getBillHeaderWiseReport } = networkList;
            let tableHead = [
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                },
                {
                    "key": 'patient_umr',
                    'label': 'Patient UMR'
                },
                {
                    "key": 'ip_no',
                    'label': 'IP Number'
                },
                {
                    "key": 'payer_type',
                    'label': 'Payer Type'
                },
                {
                    "key": 'patient_age',
                    'label': 'Patient Age',
                }, {
                    "key": 'patient_gender',
                    'label': 'Patient Gender'
                },
                {
                    "key": 'department_name',
                    'label': 'Department Name'
                },
                {
                    "key": 'doctor_name',
                    'label': 'Doctor Name'
                },
                {
                    "key": 'procedure_name',
                    'label': 'Procedure Name'
                },
                {
                    "key": 'ward_name',
                    'label': 'Ward Name'
                },
                {
                    "key": 'nurse_station_name',
                    'label': 'Nurse Station Name'
                },
                {
                    "key": 'is_iccu',
                    'label': 'Is ICCU'
                },
                {
                    "key": 'block',
                    'label': 'Block'
                },
                {
                    "key": 'floor',
                    'label': 'Floor '
                },
                {
                    "key": 'privilege_name',
                    'label': 'Privilege Name'
                }, {
                    "key": 'counselled_room_amount',
                    'label': 'Room Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_room_amount',
                    'label': 'Room Billed Amount (Rs.)'
                },
                {
                    "key": 'room_variance',
                    'label': 'Room Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_professional_amount',
                    'label': 'Professional Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_professional_amount',
                    'label': 'Professional Billed Amount (Rs.)'
                },
                {
                    "key": 'professional_variance',
                    'label': 'Professional Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_pharmacy_amount',
                    'label': 'Pharmacy Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_pharmacy_amount',
                    'label': 'Pharmacy Billed Amount (Rs.)'
                },
                {
                    "key": 'pharmacy_variance',
                    'label': 'Pharmacy Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_investigation_amount',
                    'label': 'Investigation Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_investigation_amount',
                    'label': 'Investigation Billed Amount (Rs.)'
                },
                {
                    "key": 'investigation_variance',
                    'label': 'Investigation Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_service_amount',
                    'label': 'Service Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_service_amount',
                    'label': 'Service Billed Amount (Rs.)'
                },
                {
                    "key": 'service_variance',
                    'label': 'Service Variance Amount (Rs.)'
                },
                {
                    "key": 'final_counselled_by',
                    'label': 'Final Counselled By'
                },
                {
                    "key": 'latest_estimated_amt',
                    'label': 'Total Counselled Amount (Rs.)'
                },
                {
                    "key": 'app_bill_amount',
                    'label': 'Total Billed Amount (Rs.)'
                },
                {
                    "key": 'total_variance',
                    'label': 'Total Variance Amount (Rs.)'
                },
                {
                    "key": 'unit_name',
                    'label': 'Unit Name'
                },
            ]
            this.setState((state) => ({ showFilter: true, tableTitle: 'Bill Header Wise report', thead: tableHead, filename: 'Bill-Header-Wise-Report.csv', loadding: true, download_btn: true, downloadStatus: 0 }), () => {
                postService(getBillHeaderWiseReport, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "from": moment(this.state.dateFrom).format('YYYY-MM-DD'),
                        "to": moment(this.state.dateTo).format('YYYY-MM-DD'),
                        "export": 0, //1 for download excel
                        "page_no": isDatefilter ? 1 : activePage
                    }
                }).then(res => {

                    if (res.status) {

                        this.setState((state) => ({ totalItemsCount: res.total_items, tbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                    // enable downloadbtn after 2sec
                    setTimeout(function () {
                        This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
            // setTimeout(function () {
            //     This.setState((state) => ({ downloadStatus: 0, showFilter: true, tableTitle: 'Bill Header Wise report', thead: tableHead, filename: 'Bill-Header-Wise-Report.csv', download_btn: true }), () => {
            //         postService(getBillHeaderWiseReport, 'POST', {
            //             "data": {
            //                 "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
            //                 "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
            //                 "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
            //                 "export": 1, //1 for download excel
            //                 "page_no": 0
            //             }
            //         }).then(res => {
            //             console.log('bill header report:', res);
            //             if (res.status) {
            //                 if (res.data && res.data.admissions_data) {
            //                     res.data.admissions_data.map((data, key) => {
            //                         Object.keys(data).map((dataKey) => {
            //                             res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
            //                         })
            //                     })
            //                 }
            //                 This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
            //             } else {
            //                 if (res === 401) {

            //                 } else {
            //                     Modal.error({
            //                         title: 'Failure',
            //                         content: "Oops! something went wrong... Please try again.",
            //                     });
            //                 }
            //             }
            //         });
            //     });
            // }, 3000);

        } catch (error) {
            console.log(error);
        }
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
        }), () => {
            this.loadPage(true);
        })
    }
    downloadFile = (isDatefilter = false) => {
        try {
            let This = this;
            let { activePage } = this.state;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getBillHeaderWiseReport } = networkList;
            let tableHead = [
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                },
                {
                    "key": 'patient_umr',
                    'label': 'Patient UMR'
                },
                {
                    "key": 'ip_no',
                    'label': 'IP Number'
                },
                {
                    "key": 'payer_type',
                    'label': 'Payer Type'
                },
                {
                    "key": 'patient_age',
                    'label': 'Patient Age',
                }, {
                    "key": 'patient_gender',
                    'label': 'Patient Gender'
                },
                {
                    "key": 'department_name',
                    'label': 'Department Name'
                },
                {
                    "key": 'doctor_name',
                    'label': 'Doctor Name'
                },
                {
                    "key": 'procedure_name',
                    'label': 'Procedure Name'
                },
                {
                    "key": 'ward_name',
                    'label': 'Ward Name'
                },
                {
                    "key": 'nurse_station_name',
                    'label': 'Nurse Station Name'
                },
                {
                    "key": 'is_iccu',
                    'label': 'Is ICCU'
                },
                {
                    "key": 'block',
                    'label': 'Block'
                },
                {
                    "key": 'floor',
                    'label': 'Floor '
                },
                {
                    "key": 'privilege_name',
                    'label': 'Privilege Name'
                }, {
                    "key": 'counselled_room_amount',
                    'label': 'Room Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_room_amount',
                    'label': 'Room Billed Amount (Rs.)'
                },
                {
                    "key": 'room_variance',
                    'label': 'Room Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_professional_amount',
                    'label': 'Professional Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_professional_amount',
                    'label': 'Professional Billed Amount (Rs.)'
                },
                {
                    "key": 'professional_variance',
                    'label': 'Professional Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_pharmacy_amount',
                    'label': 'Pharmacy Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_pharmacy_amount',
                    'label': 'Pharmacy Billed Amount (Rs.)'
                },
                {
                    "key": 'pharmacy_variance',
                    'label': 'Pharmacy Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_investigation_amount',
                    'label': 'Investigation Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_investigation_amount',
                    'label': 'Investigation Billed Amount (Rs.)'
                },
                {
                    "key": 'investigation_variance',
                    'label': 'Investigation Variance Amount (Rs.)'
                }, {
                    "key": 'counselled_service_amount',
                    'label': 'Service Counselled Amount (Rs.)'
                },
                {
                    "key": 'billed_service_amount',
                    'label': 'Service Billed Amount (Rs.)'
                },
                {
                    "key": 'service_variance',
                    'label': 'Service Variance Amount (Rs.)'
                },
                {
                    "key": 'final_counselled_by',
                    'label': 'Final Counselled By'
                },
                {
                    "key": 'latest_estimated_amt',
                    'label': 'Total Counselled Amount (Rs.)'
                },
                {
                    "key": 'app_bill_amount',
                    'label': 'Total Billed Amount (Rs.)'
                },
                {
                    "key": 'total_variance',
                    'label': 'Total Variance Amount (Rs.)'
                },
                {
                    "key": 'unit_name',
                    'label': 'Unit Name'
                },
            ]
                This.setState((state) => ({ downloadStatus: 0, thead: tableHead, filename: 'Bill-Header-Wise-Report.csv', download_btn: true, loadding: true  }), () => {
                    postService(getBillHeaderWiseReport, 'POST', {
                        "data": {
                            "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                            "from": moment(This.state.dateFrom).format('YYYY-MM-DD'),
                            "to": moment(This.state.dateTo).format('YYYY-MM-DD'),
                            "export": 1, //1 for download excel
                            "page_no": 0
                        }
                    }).then(res => {
                        console.log('bill header report:', res);
                        if (res.status) {
                            if (res.data && res.data.admissions_data) {
                                res.data.admissions_data.map((data, key) => {
                                    Object.keys(data).map((dataKey) => {
                                        res.data.admissions_data[key][dataKey] = res.data.admissions_data[key][dataKey] ? res.data.admissions_data[key][dataKey] : 'NA'
                                    })
                                })
                            }
                            This.setState((state) => ({ downloadStatus: 1, downloadtbody: res.data.admissions_data ? res.data.admissions_data : res.data, loadding: false }));
                            this.csvLink.current.link.click();
                        } else {
                            if (res === 401) {

                            } else {
                                Modal.error({
                                    title: 'Failure',
                                    content: "Oops! something went wrong... Please try again.",
                                });
                            }
                        }
                    });
                });

        } catch (error) {
            console.log(error);
        }
    }
    render() {
        let { filtereData, activePage, totalItemsCount, downloadStatus, downloadtbody, tableTitle, thead, tbody, filename, download_btn, select2 } = this.state;
        return (
            <div>
                {
                    download_btn
                        ?
                        downloadStatus && tbody != ''
                            ?
                            <div className="row mb-2 ml-5 mr-5 download sticky-top d-flex flex-row-reverse">
                                {/* <CSVLink data={downloadtbody} headers={thead} filename={filename}>
                                    <button className="btn btn-success text-capitalize float-left"><img src="/assets/images/icons/download1.png" alt="" className="pr-2" /> <span> Download Report</span></button>
                                </CSVLink> */}
                                <button className="btn btn-success text-capitalize float-left" onClick={()=>{this.downloadFile()}}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                            </div>
                            :
                            <div className="row mb-2 ml-5 mr-5 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize float-left" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                            </div>
                        :
                        <div className="mt-5" />
                }
                <Spin spinning={this.state.loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="float-left pt-1">
                                    {tableTitle}
                                </div>
                                <div >
                                    {filtereData
                                        .map((feild, key) => {
                                            if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}
                                                        
                                                        <DateRange
                                                            Queuedata={filtereData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({  dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                        />
                                                        <div class="input-group-append">
                                                            <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                        </div>
                                                        {/* ; this.loadPage(true) */}
                                                    </div>
                                                )
                                            }
                                        })}
                                </div>
                            </div>
                        </div>
                        <div className="financial-table table-responsive sticky-header2" id="table2">
                            <table className="table table-hover table-bordered mb-0 bg-white">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle" rowSpan="2">S.no</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Patient Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Patient UMR</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">IP Number</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Payer Type</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Patient Age</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Patient Gender</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Department Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Doctor Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Procedure Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Privilege Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Ward Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Nurse Station Name</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Is ICCU</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Block</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Floor</td>
                                        <td className="text-capitalize text-center" colspan="3">room charges</td>
                                        <td className="text-capitalize text-center" colspan="3">Professional charges</td>
                                        <td className="text-capitalize text-center" colspan="3">Pharmacy</td>
                                        <td className="text-capitalize text-center" colspan="3">Investigations</td>
                                        <td className="text-capitalize text-center" colspan="3">Services</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Final Counselled By</td>
                                        <td className="text-capitalize text-center" colspan="3">Total</td>
                                        <td className="text-capitalize align-middle" rowSpan="2">Unit Name</td>
                                    </tr>
                                    <tr>
                                        <td className="text-capitalize">Counselled amount (Rs.)</td>
                                        <td className="text-capitalize">billed amount (Rs.)</td>
                                        <td className="text-capitalize">variance (Rs.)</td>
                                        <td className="text-capitalize">Counselled amount (Rs.)</td>
                                        <td className="text-capitalize">billed amount (Rs.)</td>
                                        <td className="text-capitalize">variance (Rs.)</td>
                                        <td className="text-capitalize">Counselled amount (Rs.)</td>
                                        <td className="text-capitalize">billed amount (Rs.)</td>
                                        <td className="text-capitalize">variance (Rs.)</td>
                                        <td className="text-capitalize">Counselled amount (Rs.)</td>
                                        <td className="text-capitalize">billed amount (Rs.)</td>
                                        <td className="text-capitalize">variance (Rs.)</td>
                                        <td className="text-capitalize">Counselled amount (Rs.)</td>
                                        <td className="text-capitalize">billed amount (Rs.)</td>
                                        <td className="text-capitalize">variance (Rs.)</td>
                                        <td className="text-capitalize">Counselled amount (Rs.)</td>
                                        <td className="text-capitalize">billed amount (Rs.)</td>
                                        <td className="text-capitalize">variance (Rs.)</td>
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key}>
                                                    <td>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    <td className="text-capitalize">{(body.patient_name !== null) ? body.patient_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.patient_umr !== null) ? body.patient_umr : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.ip_no !== null) ? body.ip_no : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.payer_type !== null) ? body.payer_type : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.patient_age !== null) ? body.patient_age : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.patient_gender !== null) ? body.patient_gender : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.department_name !== null) ? body.department_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.doctor_name !== null) ? body.doctor_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.procedure_name !== null) ? body.procedure_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.privilege_name !== null) ? body.privilege_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.privilege_name !== null) ? body.ward_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.ward_name !== null) ? body.nurse_station_name : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.is_iccu !== null) ? body.is_iccu : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.block !== null) ? body.block : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.floor !== null) ? body.floor : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.counselled_room_amount !== null) ? body.counselled_room_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.billed_room_amount !== null) ? body.billed_room_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.room_variance !== null) ? body.room_variance : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.counselled_professional_amount !== null) ? body.counselled_professional_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.billed_professional_amount !== null) ? body.billed_professional_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.professional_variance !== null) ? body.professional_variance : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.counselled_pharmacy_amount !== null) ? body.counselled_pharmacy_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.billed_pharmacy_amount !== null) ? body.billed_pharmacy_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.pharmacy_variance !== null) ? body.pharmacy_variance : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.counselled_investigation_amount !== null) ? body.counselled_investigation_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.billed_investigation_amount !== null) ? body.billed_investigation_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.investigation_variance !== null) ? body.investigation_variance : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.counselled_service_amount !== null) ? body.counselled_service_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.billed_service_amount !== null) ? body.billed_service_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.service_variance !== null) ? body.service_variance : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.final_counselled_by !== null) ? body.final_counselled_by : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.latest_estimated_amt !== null) ? body.latest_estimated_amt : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.app_bill_amount !== null) ? body.app_bill_amount : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.total_variance !== null) ? body.total_variance : 'NA'}</td>
                                                    <td className="text-capitalize">{(body.unit_name !== null) ? body.unit_name : 'NA'}</td>

                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="20" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>
                    </div>
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            {/* <Pagination

                                activePage={this.state.activePage}
                                itemsCountPerPage={20}
                                totalItemsCount={totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}
                            /> */}
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />

                        </div>
                    </div>
                </Spin>
            </div>
        )
    }
}

export default Bill_Header_Wise;